"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./LinkTile.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _LinkTileMethods = require("./LinkTileMethods");
var _checkForRenderAnchorTag = require("../../utils/methods/checkForRenderAnchorTag");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//This molecule has been updated for Luna One

const LinkTile = _ref => {
  let {
    content,
    color = "#242D2F",
    backgroundColor = "#F8F8FB"
  } = _ref;
  const {
    header,
    text,
    link,
    Link
  } = content;
  const {
    mouse
  } = (0, _useMouse.default)();
  const componentJSX = () => {
    return /*#__PURE__*/_react.default.createElement("article", {
      className: "ter-link-tile",
      tabIndex: mouse ? "" : "0"
      // id={useId()}
      ,
      style: {
        backgroundColor: backgroundColor || "#242D2F"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-link-tile__link-wrapper",
      tabIndex: mouse ? "" : "0"
      // id={useId()}
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      tabIndex: mouse ? "" : "0"
      // id={useId()}
      ,
      Link: Link && Link,
      className: mouse ? "ter-link-tile__header" : "ter-link-tile__header tagFocus",
      style: {
        color: (0, _LinkTileMethods.getLinkColor)(color)
      },
      to: link.url
    }, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
    })), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "enclosed-caret-right-dark-24px",
      size: "24px",
      color: color ? color : "#363545"
    })), text && (0, _checkForDangerouslySet.checkAndSet)(text, "ter-link-card", "body", color));
  };
  return componentJSX();
};
var _default = LinkTile;
exports.default = _default;
LinkTile.propTypes = {
  content: _propTypes.default.shape({
    header: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    link: _propTypes.default.shape({
      url: _propTypes.default.string.isRequired
    })
  })
};